<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseNode from './BaseNode.vue';

const props = defineProps({
  id: { type: String, required: true },
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();

const items = computed(() => (props.data.items || []).filter(Boolean));
</script>

<template>
  <BaseNode
    :node-id="props.id"
    :selected="selected"
    icon="i-lucide-list-checks"
    :type-label="t('SOPS.NODES.ACTION')"
    :node-label="data.label"
    accent-class="bg-n-iris-9/15 text-n-iris-11"
  >
    <ul
      v-if="items.length"
      class="mb-0 flex list-none flex-col gap-2 border-t border-n-weak p-3"
    >
      <li
        v-for="(item, index) in items"
        :key="index"
        class="flex items-start gap-2 text-sm text-n-slate-11"
      >
        <span class="i-lucide-square mt-1 size-3 shrink-0" />
        <span class="min-w-0 break-words">{{ item }}</span>
      </li>
    </ul>
  </BaseNode>
</template>
